import { supabase } from '../../../services/supabase';
import { TAssessmentResult } from '../types/types';

export async function submitFeedbackUsage(
  ticketCheckInId: string,
  assessments: TAssessmentResult[],
): Promise<void> {
  const rows = assessments.map(({ isAiSuggestionAccepted, input, ...raw }) => ({
    input_text: input,
    feedback_text: raw.suggested_rewritten_check_in,
    is_accepted: isAiSuggestionAccepted,
    created_at: new Date().toISOString(),
    ticket_check_in_id: ticketCheckInId,
    failed_checks: Object.entries(raw)
      .filter(([_, value]) => value === false)
      .map(([key]) => key),
  }));

  await supabase.from('ai_feedback').insert(rows);
}
